import numberOfAiGeneratedBlocks from './number-of-ai-generated-blocks';

export default {
  numberOfAiGeneratedBlocks,
};
